import _slicedToArray from "D:\\loc\\loc-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import t, { createContext as e, useMemo as o, useEffect as r, useContext as s, useState as n } from "react";
import i from "zustand";
import { HMSReactiveStore as a } from "@100mslive/hms-video-store";
import { makeHMSStoreHook as c, makeHMSStatsStoreHook as f, hooksErrorMessage as u } from "./store.js";
import { isBrowser as w } from "../utils/isBrowser.js";
var d = e(null),
  l = function l(_ref) {
    var e = _ref.children,
      s = _ref.actions,
      n = _ref.store,
      c = _ref.notifications,
      f = _ref.stats,
      _ref$isHMSStatsOn = _ref.isHMSStatsOn,
      u = _ref$isHMSStatsOn === void 0 ? !1 : _ref$isHMSStatsOn,
      _ref$leaveOnUnload = _ref.leaveOnUnload,
      l = _ref$leaveOnUnload === void 0 ? !0 : _ref$leaveOnUnload;
    var m = o(function () {
      var e;
      var o = function o() {
        throw new Error("modifying store is not allowed");
      };
      if (s && n) e = {
        actions: s,
        store: i(Object.assign(Object.assign({}, n), {
          setState: o,
          destroy: o
        }))
      }, c && (e.notifications = c), f && (e.statsStore = i({
        getState: f.getState,
        subscribe: f.subscribe,
        setState: o,
        destroy: o
      }));else {
        var _t = new a();
        if (e = {
          actions: _t.getActions(),
          store: i(Object.assign(Object.assign({}, _t.getStore()), {
            setState: o,
            destroy: o
          })),
          notifications: _t.getNotifications()
        }, u) {
          var _r = _t.getStats();
          e.statsStore = i({
            getState: _r.getState,
            subscribe: _r.subscribe,
            setState: o,
            destroy: o
          });
        }
      }
      return e.actions.setFrameworkInfo({
        type: "react-web",
        version: t.version,
        sdkVersion: "0.6.4"
      }), e;
    }, [s, n, c, f, u]);
    return r(function () {
      if (w && l) {
        var _t2 = function _t2() {
          return m.actions.leave();
        };
        return window.addEventListener("beforeunload", _t2), function () {
          window.removeEventListener("beforeunload", _t2);
        };
      }
      return function () {};
    }, [l, m]), t.createElement(d.Provider, {
      value: m
    }, e);
  },
  m = c(d),
  b = f(d),
  S = function S() {
    var t = s(d);
    if (!t) throw new Error(u);
    return t.store;
  },
  g = function g() {
    var t = s(d);
    if (!t) throw new Error(u);
    return t.notifications;
  },
  v = function v() {
    var t = s(d);
    if (!t) throw new Error(u);
    return t.actions;
  },
  E = function E(t) {
    var e = s(d),
      _n = n(null),
      _n2 = _slicedToArray(_n, 2),
      o = _n2[0],
      i = _n2[1];
    if (!e) throw new Error(u);
    return r(function () {
      if (!e.notifications) return;
      return e.notifications.onNotification(function (t) {
        i(t);
      }, t);
    }, [e.notifications, t]), o;
  };
export { l as HMSRoomProvider, v as useHMSActions, E as useHMSNotifications, b as useHMSStatsStore, m as useHMSStore, g as useHMSVanillaNotifications, S as useHMSVanillaStore };